export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CardNotaItem.vue?vue&type=template&id=619f5274&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/CardNotaItem.vue?vue&type=template&id=619f5274&
// module id = 801
// module chunks = 0